import { ChainIdEnum } from "../../enums/chain";
import { arbitrumConfig } from "./configs/arbitrum";
import { arbitrumTestnetConfig } from "./configs/arbitrum-testnet";
import { arcTestnetConfig } from "./configs/arc";
import { basecampTestnetConfig } from "./configs/basecamp";
import { bnbTestnetConfig } from "./configs/bnb-testnet";
import { dogeosTestnetConfig } from "./configs/dogeos";
import { ethMainnetConfig } from "./configs/eth-mainnet";
import { megaethTestnetConfig } from "./configs/megaeth";
import { monadTestnetConfig } from "./configs/monad";
import { noneConfig } from "./configs/none";
import { optimismConfig } from "./configs/optimism";
import { optimismTestnetConfig } from "./configs/optimism-testnet";
import { sepoliaTestnetConfig } from "./configs/sepolia";
import { ChainConfig } from "./types";

/**
 * Complete chain configurations map
 * Single source of truth for all chain-related data
 */
export const CHAIN_CONFIGS: Map<ChainIdEnum, ChainConfig> = new Map([
  // ============================================
  // NONE (placeholder)
  // ============================================
  [ChainIdEnum.NONE, noneConfig],

  // ============================================
  // ETH MAINNET (Chain ID: 1)
  // ============================================
  [ChainIdEnum.ETH_MAINNET, ethMainnetConfig],

  // ============================================
  // SEPOLIA TESTNET (Chain ID: 11155111)
  // ============================================
  [ChainIdEnum.SEPOLIA_TESTNET, sepoliaTestnetConfig],

  // ============================================
  // BASECAMP TESTNET (Chain ID: 123420001114)
  // ============================================
  [ChainIdEnum.BASECAMP_TESTNET, basecampTestnetConfig],

  // ============================================
  // MEGAETH TESTNET (Chain ID: 6343)
  // ============================================
  [ChainIdEnum.MEGAETH_TESTNET, megaethTestnetConfig],

  // ============================================
  // OPTIMISM (Chain ID: 10)
  // ============================================
  [ChainIdEnum.OPTIMISM, optimismConfig],

  // ============================================
  // OPTIMISM TESTNET (Chain ID: 11155420)
  // ============================================
  [ChainIdEnum.OPTIMISM_TESTNET, optimismTestnetConfig],

  // ============================================
  // ARBITRUM (Chain ID: 42161)
  // ============================================
  [ChainIdEnum.ARBITRUM, arbitrumConfig],

  // ============================================
  // ARBITRUM TESTNET (Chain ID: 421614)
  // ============================================
  [ChainIdEnum.ARBITRUM_TESTNET, arbitrumTestnetConfig],

  // ============================================
  // BNB TESTNET (Chain ID: 97)
  // ============================================
  [ChainIdEnum.BNB_TESTNET, bnbTestnetConfig],

  // ============================================
  // DOGEOS TESTNET (Chain ID: 6281971)
  // ============================================
  [ChainIdEnum.DOGEOS_TESTNET, dogeosTestnetConfig],

  // ============================================
  // MONAD TESTNET (Chain ID: 10143)
  // ============================================
  [ChainIdEnum.MONAD_TESTNET, monadTestnetConfig],

  // ============================================
  // ARC TESTNET (Chain ID: 5042002)
  // ============================================
  [ChainIdEnum.ARC_TESTNET, arcTestnetConfig],
]);

/**
 * Get list of all configured chain IDs
 */
export const getConfiguredChainIds = (): ChainIdEnum[] => {
  return Array.from(CHAIN_CONFIGS.keys());
};

/**
 * Check if a chain ID is configured
 */
export const isChainConfigured = (chainId: ChainIdEnum): boolean => {
  return CHAIN_CONFIGS.has(chainId);
};
